module.exports = __webpack_public_path__ + "static/media/apple.5e37d487.svg";